<template>
 
  <div>

    <DevicesListFilters :filterFor="report_type" :oldFilterData="request" @divicesFilterd="divicesFilterd"
                        @merageFilterWithRequest="merageFilterWithRequest" />


    <!-- form report -->

    <b-card style="position: relative">
      <div v-if="loading" class="loading_page">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <b-form @submit.prevent="getReport" class="">

        <b-row class="mt-2">
          <!-- devices  -->
          <b-col :cols="report_type === 'report' ? 6 : 12">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices"
                :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="d => d.name"
                :options="[{ name: $t('all'), id: 'all' }, ...devices]" :reduce="d => d.id" />
              <p v-if="errors && ('devices' in errors)" class="text-danger">
                * {{ $t(errors['devices'][0]) }}
              </p>
            </b-form-group>
          </b-col>
          <b-col v-if="report_type === 'report'" md="6" sm="6">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                * {{ $t('Date range is mandatory') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

<!--          <b-col v-if="report_type === 'report'" md="2" sm="2">-->
<!--            &lt;!&ndash; report range date &ndash;&gt;-->
<!--            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">-->
<!--              <flat-pickr ref="end_date_ref" v-model="rangeDate" :state="null" class="form-control" :config="{ ...end_picker_ops }"-->
<!--                          placeholder="YYYY-MM-DD" />-->

<!--              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"-->
<!--                                       :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">-->
<!--                * {{ $t('Date range is mandatory') }}-->
<!--              </b-form-invalid-feedback>-->
<!--            </b-form-group>-->
<!--          </b-col>-->

        </b-row>

        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col v-if="report_type === 'report'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>

          <b-col v-if="report_type === 'setting'" cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="button" variant="primary" class="mr-1"
              @click="saveDialySetting('sweep')">
              {{ $t('Save Settings') }}
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </b-card>

    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData" />
    </div>

  </div>

</template>

<script>
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, onMounted,onUpdated} from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'
import { ExportDataServices } from '@/share/reports/exportService'
import reportForm from '@/app/reports/share/reportForm'
import ReportLogic from '@/app/reports/distance/logic'

import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import { ReportSetting } from '@/views/reports/ReportSettings'
import DataTable from '@/views/reports/data-table/DataTable.vue'


import ReportOptions from '@/views/reports/components/options.js'



export default {
  name: 'DistanceReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    ToggleCollapse,
    DevicesListFilters, DataTable
  },
  directives: { Ripple, },

  props: {
    report_type: {
      type: String,
      default: 'report'

    }
  },
  setup(props, { root }) {


    const new_range = ref([])

    const { devices } = FilterLogic()
    const divicesFilterd = (data) => {
      devices.value = data;
    }
    const merageFilterWithRequest = (data) => {
      delete data['type']
      Object.assign(request.value, data);
    }

    const rangeDate = ref('')
    const tableRef = ref(null)
    const { owners, contracts, reFilterDevices } = reportForm()
    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to,isSortDirDesc,sortBy,dataTableloading } = ReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }
    const perPageOptions = [5, 10, 25, 50, 100]
    const { pickerOptions } = ReportOptions(request.value)
    const report_wrapper = ref(null)

    const filter_included_fields = ['device_name', 'date', 'device_owner', 'device_contract', 'distance'];
    const report_fields = ref([
      {
        key: 'id',
        label:'id',

      },
      {
        key: 'device_owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'device_contract',
        label: 'contract',
        sortable: true
      },
      {
        key: 'device_name',
        label: 'device',
        sortable: true
      },
      {
        key: 'device_category',
        label: 'category',
        sortable: true
      },

      {
        key: 'date',
        label: 'date',
        sortable: true
      },

      {
        key: 'distance_km',
        label:'distance',
        sortable: true
      },
    ]);

    const end_date_ref = ref()

    const start_picker_ops = {
      dateFormat: 'Y-m-d H:i:S',
      defaultDate: new Date().setHours(0,0,0),
      enableTime: true,
      enableSeconds: true,
      defaultHour: 0,
      time_24hr: true,
      onClose: function(selectedDates, dateStr, instance) {

      },
      onOpen: () => {

        console.log("opened")
        console.log(end_date_ref.value)
        if (end_date_ref.value?.fp) {
          end_date_ref.value.fp.open()
        }
      }
    }

    const end_picker_ops = {
      dateFormat: 'Y-m-d H:i:S',
      defaultDate: new Date().setHours(0,0,0),
      enableTime: true,
      enableSeconds: true,
      defaultHour: 0,
      time_24hr: true,
    }

    /// here use root form ass dialy report setting
    const ext_filter = ref(null);
    const toaster = (msg, variant = 'success', title = 'Success') => {
      root.$root.$bvToast.toast(
        root.$i18n.t(msg), {
        title: root.$i18n.t(title),
        variant,
        solid: true,
      })
    }
    const saveDialySetting = (reportName) => {
      let setting_data = request.value;
      delete setting_data.to;
      delete setting_data.from;

      ReportSetting.setSettings(reportName, setting_data).then((res) => {
        toaster('settings saved successfully!!', 'success!!')
      }).catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    }

    onMounted(() => {
      ReportSetting.getSetting('sweep').then((res) => {

        request.value = res;
        ext_filter.value = res;
      })
    })


    return {
      report_data, filter_included_fields, report_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,


      getReportForPdf,
      pickerOptions,
      report_wrapper,


      request,
      loading,
      errors,
      devices,
      owners,
      contracts,
      reFilterDevices,
      divicesFilterd,
      merageFilterWithRequest,
      ///dialy report settings is here

      saveDialySetting,
      ext_filter,
      sortData,
      dataTableloading,


      new_range,
      start_picker_ops,
      end_picker_ops,
      end_date_ref
    }


  },



}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}

.group-row {
  background-color: #ddd;
}
</style>